export enum GlobalMyAccountToolsRoutes {
  BASE = 'myaccount-tools',
  GENERAL_TOOLS = 'general-tools',
  REPAIR = 'repair',
  RETURN = 'return',
  REPAIR_TRACKING = 'repair-tracking',
  REORDER_LABELS = 'reorder-labels',
  LOST_STOLEN = 'lost-stolen',
  COST_CENTER_LIST = 'change-cost-center-list',
  FLEET_EXCHANGE = 'fleet-exchange',
  LOAN = 'loan',
  PEAK = 'peak',
  CIRCULARITY_REPORTS = 'circularity-reports'
}

export const MyAccountToolsFullModeRoutes = {
  ...GlobalMyAccountToolsRoutes,
  REPAIR_TRACKING_DETAILS: 'repair-tracking/[\\d\\w]*(/|/success|/error)?'
};
